module.exports = __webpack_public_path__ + "img/zuijia_01.8725e8fe.png";